// Single place that defines the "task:status" event shape emitted by every long-running
// tool operation, so the system status bar (src/core/ui/shell.js) has one contract to read
// instead of each tool file independently reinventing the emit call.
export function reportTaskStatus(app, source, { label, message = "", progress = null, status = "running", projectCode = null } = {}) {
  app?.events?.emit?.("task:status", { source, label, message, progress, status, projectCode });
}
